/**
 * Represents a placed prop instance on the map
 */
export interface PropInstance {
  /** Unique identifier for this prop instance */
  id: string;
  /** Name of the prop asset (references assets/props/{name}) */
  propName: string;
  /** World X position (in pixels) */
  x: number;
  /** World Y position (in pixels) */
  y: number;
  /** Scale factor (1 = original size) */
  scale: number;
  /** Rotation in degrees (0-360) */
  rotation: number;
  /** Z-index for layering (higher = rendered on top) */
  zIndex: number;
}

/**
 * Props data for a single region
 */
export interface RegionProps {
  /** Region X coordinate */
  regionX: number;
  /** Region Y coordinate */
  regionY: number;
  /** List of props in this region */
  props: PropInstance[];
}

/**
 * Prop asset metadata
 */
export interface PropAsset {
  name: string;
  width: number;
  height: number;
}

/**
 * Settings for the prop placement tool
 */
export interface PropToolSettings {
  /** Currently selected prop asset name */
  selectedProp: string | null;
  /** Scale factor for new props */
  scale: number;
  /** Rotation in degrees for new props */
  rotation: number;
}

/**
 * Default prop tool settings
 */
export const DEFAULT_PROP_TOOL_SETTINGS: PropToolSettings = {
  selectedProp: null,
  scale: 1,
  rotation: 0
};
